import React from "react";
import "../styles/errorMessage.css";

interface IErrorMessage {
  errorText: string;
}

const ErrorMessage: React.FC<IErrorMessage> = ({ errorText }: IErrorMessage): React.JSX.Element => {
  const onClickButtonReload = (): void => {
    location.reload();
  };

  return (
    <div className="errorPage" data-testid="errorMessage">
      <span className="errorPage__errorText">{errorText}</span>
      <button className="errorPage__buttonReload" onClick={onClickButtonReload}>
        Перезагрузить плагин
      </button>
    </div>
  );
};

export default ErrorMessage;
